module.exports = __webpack_public_path__ + "img/course_bg2.a9c9cc55.png";